import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

import NotFound from '../pages/NotFound.vue'
import Index from '../pages/Index.vue'
import Home from '../pages/Home.vue'
import EmailVerification from '../pages/EmailVerification.vue'

const router = new VueRouter({
  // mode: 'history',
  base: __dirname,
  routes: [
    {
      path: '/',
      name: 'index',
      component: Index
    },
    {
      path: '/home',
      name: 'home',
      component: Home
    },
    {
      path: '/verification',
      name: 'emailverification',
      component: EmailVerification
    },
    // {
    //   path: '/detail/:id',
    //   name: 'detail',
    //   component: require('../pages/Login.vue')
    // }
    {
      path: '*',
      name: 'notfound',
      component: NotFound
    },
  ]
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js